class StickyProductActions extends HTMLElement {
  constructor() {
    super();
    this.preventStickyHeader();
  }

  preventStickyHeader() {
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (!this.stickyHeader) return;
    this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }

  connectedCallback() {
    this.productDetails = document.getElementById('description');
    this.currentScrollTop = 0;
    this.currentHeight = this.offsetHeight;

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.productDetails.offsetTop) {
      requestAnimationFrame(this.reveal.bind(this));
    } else {
      requestAnimationFrame(this.hide.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.classList.remove('sticky-product-actions--visible');
    document.body.classList.remove('sticky-product-actions-padding');
  }

  reveal() {
    this.classList.add('sticky-product-actions--visible');
    document.body.classList.add('sticky-product-actions-padding');
  }
}

customElements.define('sticky-product-actions', StickyProductActions);